import classNames from 'classnames';
import * as React from 'react';

import { INavbarLink } from '../../types/navbar';
import { ERubric } from '../../types/rubricsLinks';
import * as styles from './NavBar.css';

interface INavBarProps {
  rubricsLinks: INavbarLink[];
  specialPromo: React.ReactNode;
  onItemMouseOver(rubric: ERubric): void;
  onItemMouseOut(): void;
}

export const NavBar: React.FC<INavBarProps> = ({ rubricsLinks, specialPromo, onItemMouseOut, onItemMouseOver }) => {
  return (
    <nav className={styles['navigation']}>
      <ul className={styles['list']}>
        {rubricsLinks.map(({ rubric, active, hovered, title, url }) => {
          return (
            <li
              key={rubric}
              className={classNames({
                [styles['list-item']]: true,
                [styles['active']]: active,
                [styles['hovered']]: hovered,
              })}
              onMouseOver={() => onItemMouseOver(rubric)}
              onMouseOut={onItemMouseOut}
            >
              {url && (
                <a className={styles['link']} href={url}>
                  {title}
                </a>
              )}
              {!url && <span className={styles['link']}>{title}</span>}
            </li>
          );
        })}
      </ul>
      {specialPromo && <div className={styles['special-promos']}>{specialPromo}</div>}
    </nav>
  );
};
